import { getSessionToken } from '@/libs/session-management';

export const authValidation = () => {
  return Boolean(getSessionToken());
};

/**
 * Takes a user profile object and returns the initials based on the full name or email.
 * If the full name is not available, it uses the first two letters of the email.
 */
export function getInitials(profile: { full_name?: string; email?: string } = {}): string {
  const name = profile?.full_name?.trim();
  if (name) {
    const parts = name.split(/\s+/);
    if (parts.length > 1) {
      // Use first letter of first and last name
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    } else if (parts[0].length >= 2) {
      // Use first two letters of the single name
      return parts[0].slice(0, 2).toUpperCase();
    } else if (parts[0].length === 1) {
      return (parts[0][0] + (profile.email?.[0] ?? '-')).toUpperCase();
    }
  }
  // Fallback to first two letters of email
  if (profile?.email) {
    return profile.email.slice(0, 2).toUpperCase();
  }
  return '--';
}
